import { render } from "./ImagePickerEditorCmp.vue?vue&type=template&id=0c2e0d90"
import script from "./ImagePickerEditorCmp.vue?vue&type=script&lang=js"
export * from "./ImagePickerEditorCmp.vue?vue&type=script&lang=js"

import "./ImagePickerEditorCmp.vue?vue&type=style&index=0&id=0c2e0d90&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__